<template>
  <v-dialog v-model="dialog" persistent max-width="500px" :retain-focus="false">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"> </slot>
    </template>
    <v-card>
      <v-card-title> Share {{ name }} </v-card-title>
      <v-card-text class="pb-0 pb-2">
        <span ref="copyText">{{ courseURL }}</span>
      </v-card-text>
      <v-card-text class="d-flex pt-0 pb-2" v-if="accesscoderequired || false">
        <v-switch
          value
          hide-details=""
          input-value="true"
          color="blue"
          v-model="shareCode"
          class="ma-auto mr-0 ml-0"
        ></v-switch>
        <div class="ma-auto ml-4">Include access code</div></v-card-text
      >
      <v-card-actions>
        <v-btn color="grey lighten-2" depressed @click="$emit('finish')">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn color="primary" depressed @click="copyText()">
          Copy and Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.hidden {
  visibility: hidden;
}
</style>
<script>
export default {
  props: ["dialog", "id", "name", "accesscode", "accesscoderequired"],
  data: () => ({
    isDisabled: true,
    shareCode: false
  }),
  computed: {
    show: {
      get() {
        console.log("yay");
        return this.dialog;
      },
      set() {
        return false;
      }
    },
    courseURL() {
      return `https://${JSON.parse(
        JSON.stringify(this.$store.getters.getOrganization.subdomain)
      )}.arist.co/courses/${this.id}${
        this.shareCode ? "?accesscode=" + encodeURI(this.accesscode) : ""
      }`;
    }
  },
  methods: {
    copyTextToClipboard(text) {
      var textArea = document.createElement("textarea");

      //
      // *** This styling is an extra step which is likely not required. ***
      //
      // Why is it here? To ensure:
      // 1. the element is able to have focus and selection.
      // 2. if element was to flash render it has minimal visual impact.
      // 3. less flakyness with selection and copying which **might** occur if
      //    the textarea element is not visible.
      //
      // The likelihood is the element won't even render, not even a
      // flash, so some of these are just precautions. However in
      // Internet Explorer the element is visible whilst the popup
      // box asking the user for permission for the web page to
      // copy to the clipboard.
      //

      // Place in top-left corner of screen regardless of scroll position.
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of white box if rendered for any reason.
      textArea.style.background = "transparent";

      textArea.value = text;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Copying text command was " + msg);
      } catch (err) {
        console.log("Oops, unable to copy");
      }

      document.body.removeChild(textArea);
    },
    copyText() {
      this.copyTextToClipboard(this.courseURL);
      this.$emit("finish");
    }
  }
};
</script>
